import { createContext, useContext } from "react";

export const MenuContext = createContext(null);

export const useMenu = () => {
  const ctx = useContext(MenuContext);
  if (!ctx) {
    throw new Error("useMenu must be used inside MenuProvider");
  }
  return ctx;
};
